<template>
  <router-view />
  <!-- <GatewayToggle /> -->
</template>


<script setup>
  // import GatewayToggle from '@/components/others/GatewayToggle.vue'
</script>


<style>
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    margin: 0;
    padding: 0;
  }
</style>